/* BaseSubComponentScheduleRenderer.js */

"use strict";

const BaseScheduleRenderer = require("./BaseScheduleRenderer");

class BaseSubComponentScheduleRenderer extends BaseScheduleRenderer {
    constructor(model, rootElementName) {
        super(model);
        this._rootElem = document.createElement(rootElementName);
        this._rootElem.component = this._model;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    shutdown() {
        super.shutdown();
        this._rootElem.remove();
        this._rootElem = undefined;
    }
}
module.exports = BaseSubComponentScheduleRenderer;
